import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { ActivatedRoute, Params, Router } from "@angular/router";
import { AlertService } from "../services/alert.service";
import { AuthService } from "../services/auth.service";
import { EnvService } from "../services/env.service";
import { MatTableDataSource } from "@angular/material/table";

@Component({
  selector: "micro-hosting-platform-detail",
  templateUrl: "./cmdb-hosting-platform-detail.component.html",
})
export class CmdbHostingPlatformDetailComponent implements OnInit {
  dataSource = new MatTableDataSource<any>();
  @Input() hostingPlatformId: any;
  @Output() persisted = new EventEmitter<any>();
  hostingPlatform: any;

  constructor(
    public auth: AuthService,
    private env: EnvService,
    private http: HttpClient,
    private route: ActivatedRoute,
    private router: Router,
    private alertService: AlertService,
  ) {}

  ngOnInit(): void {
    if (this.hostingPlatformId) {
      this.load(this.hostingPlatformId);
    } else {
      this.route.params.subscribe((params: Params) => {
        params["id"] === "0" ? this.createNew() : this.load(params["id"]);
      });
    }
  }

  load(id: string): void {
    this.http
      .get(`${this.env.e.url}/domain/cmdbHostingPlatform/${id}`)
      .subscribe((data) => {
        this.hostingPlatform = data;
      });
  }

  createNew(): void {
    this.hostingPlatform = {
      code: "",
      name: "",
      description: "",
      active: "Y",
      companyId: this.auth.getCompanyId(),
    };
  }

  save(): void {
    const isUpdate = !!this.hostingPlatform.id;
    const request = isUpdate
      ? this.http.put(
          `${this.env.e.url}/domain/cmdbHostingPlatform/${this.hostingPlatform.id}`,
          this.hostingPlatform,
        )
      : this.http.post(
          `${this.env.e.url}/domain/cmdbHostingPlatform`,
          this.hostingPlatform,
        );
    request.subscribe((data) => {
      this.hostingPlatform = data;
      this.alertService.info(
        `${isUpdate ? "Updated" : "Created"} ${this.hostingPlatform.name}`,
      );
      this.persisted.emit({ data, action: isUpdate ? "updated" : "added" });
    });
  }

  delete(): void {
    this.http
      .delete(
        `${this.env.e.url}/domain/cmdbHostingPlatform/${this.hostingPlatform.id}`,
      )
      .subscribe(() => {
        this.persisted.emit({ data: this.hostingPlatform, action: "deleted" });
        this.alertService.info(`Deleted ${this.hostingPlatform.name}`);
        if (!this.hostingPlatformId) {
          this.router.navigate(["/cmdbHostingPlatform"]);
        }
      });
  }

  onCheckboxChange(event: Event): void {
    const target = event.target as HTMLInputElement;
    this.hostingPlatform.active = target.checked ? "Y" : "N";
  }
}
